import { pick } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

const selectStates = (state: RootState) => state.ui.states;
const selectNames = (_state: RootState, names?: string[]) => names;

export const selectCustomStates = createSelector([selectStates, selectNames], (states, names) => {
  if (!names?.length) return states;
  return pick(states, names);
});
